import { use, useEffect, useState } from "react";
import ERC20 from "../assets/abis/ERC20.json";
import { useChainId, useConfig } from "wagmi";
import { getAddress, isAddress } from "viem";
import { readContracts } from '@wagmi/core'
import { Token } from "../constants/types";
function usePairToken({tokenAAddress,tokenBAddress,pairAddress}) {
  const chainId = useChainId()
  const config = useConfig()
  const [data, setData] = useState(null)

  useEffect(() => {
    const fetch = async () => {
      try {
        console.log("Fetching tokens for addresses:", tokenAAddress, tokenBAddress);
        const address = getAddress(tokenAAddress)
        const result = await readContracts(config, {
          allowFailure: false,
          contracts: [
            {
              address: address,
              abi: ERC20,
              functionName: 'decimals',
            },
            {
              address: address,
              abi: ERC20,
              functionName: 'symbol',
            },
            {
              address: address,
              abi: ERC20,
              functionName: 'name',
            },
            {
              address:address,
              abi:ERC20,
              functionName: 'totalSupply'
            }
          ]
        })

        const tokenA = new Token(chainId, address, result[0], result[1], result[2],result[3])
        const addressB = getAddress(tokenBAddress)
        const resultB = await readContracts(config, {
          allowFailure: false,
          contracts: [
            {
              address: addressB,
              abi: ERC20,
              functionName: 'decimals',
            },
            {
              address: addressB,
              abi: ERC20,
              functionName: 'symbol',
            },
            {
              address: addressB,
              abi: ERC20,
              functionName: 'name',
            },
            {
              address:addressB,
              abi:ERC20,
              functionName: 'totalSupply'
            }
          ]
        })

        const tokenB = new Token(chainId, addressB, resultB[0], resultB[1], resultB[2],resultB[3])
        setData({tokenA,tokenB ,pairAddress})
      } catch (e) {
        console.log(e)
      }
    }

    if (isAddress(tokenAAddress)&&isAddress(tokenBAddress) && config) {
      fetch()
    } else {
      setData(null)
    }
  }, [fetch,tokenAAddress,tokenBAddress,pairAddress, config, chainId])

  return {data}
}

export default usePairToken